<template>
  <carousel
    :per-page="3"
    pagination-active-color="#2a2ab5"
    pagination-color="#bcc0d1"
    :per-page-custom="[
      [400, 1],
      [600, 2],
      [700, 2],
      [800, 2],
      [900, 3],
      [1200, 3],
      [1500, 3],
      [1900, 3],
    ]"
  >
    <slide
      v-for="(card, i) in carouselCardOptions"
      :key="i"
    >
      <CarouselSideCard
        :card="card"
      />
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import CarouselSideCard from '@/components/Carousel/CarouselSideCard';
import carouselCardOptions from '@/constants/carouselCardOptions';

export default {
  components: {
    CarouselSideCard,
    Carousel,
    Slide,
  },

  data() {
    return {
      slide: 3,
      sliding: null,
      carouselCardOptions,
    };
  },
};

</script>
